import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      d="M3.65 5C3.29196 5 2.94858 4.85777 2.69541 4.60459C2.44223 4.35142 2.3 4.00804 2.3 3.65C2.3 3.29196 2.44223 2.94858 2.69541 2.69541C2.94858 2.44223 3.29196 2.3 3.65 2.3C4.00804 2.3 4.35142 2.44223 4.60459 2.69541C4.85777 2.94858 5 3.29196 5 3.65C5 4.00804 4.85777 4.35142 4.60459 4.60459C4.35142 4.85777 4.00804 5 3.65 5ZM17.969 9.122L9.869 1.022C9.545 0.698 9.095 0.5 8.6 0.5H2.3C1.301 0.5 0.5 1.301 0.5 2.3V8.6C0.5 9.095 0.698 9.545 1.031 9.869L9.122 17.969C9.455 18.293 9.905 18.5 10.4 18.5C10.895 18.5 11.345 18.293 11.669 17.969L17.969 11.669C18.302 11.345 18.5 10.895 18.5 10.4C18.5 9.896 18.293 9.446 17.969 9.122Z"
      fill="#222A5C"
    />
  </svg>,

  "TagFilled"
);
